import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SeatSelection.css';
import RowSeatContainer from './RowSeatContainer';

/**
 * ## Redux imports
 */
import * as flightsActions from '../../../../redux/actions/FlightsActions';
import * as globalActions from '../../../../redux/actions/GlobalActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../../redux/selectors/Index';
import SeatSelectionController from './SeatSelectionController';

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions, flightsActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    flights: selectors.flights.getFlights(state.flights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class SeatSelection extends Component {
  static propTypes = {
    routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    flights: PropTypes.arrayOf(PropTypes.object),
    selectedPassenger: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  };

  constructor (props) {
    super(props);

    const { routeId } = props;
    this.getSeatsWithPassengers = SeatSelectionController.getSeatsWithPassengers.bind(this);
    this.selectSeat = SeatSelectionController.selectSeat.bind(this);
    let flights = props.flights && props.flights.length ? props.flights : props.flights;
    if (flights && flights.length) {
      let newState = this.getSeatsWithPassengers(flights, routeId);
      this.state = newState;
    }
  }

  componentWillReceiveProps (props) {
    let { flights } = this.state;
    const { routeId } = props;
    flights = flights && flights.length ? flights : flights;
    if (
      flights &&
      flights.length &&
      (flights !== props.flights || routeId !== this.props.routeId)
    ) {
      let newState = this.getSeatsWithPassengers(props.flights, routeId);
      this.setState(newState);
    }
  }

  render () {
    const { seats, exitRow } = this.state;
    const { selectedPassenger } = this.props;
    let rowItems = [];
    let currentRow = 1;
    if (seats && seats.length) {
      seats.sort((a, b) => a.row - b.row || a.seatId - b.seatId);
      return (
        <div className='seats-wrapper'>
          {seats.map((seat, i) => {
            if (seat.row && seat.row === currentRow) {
              rowItems.push(seat);
              if (i === seats.length - 1) {
                return (
                  <RowSeatContainer
                    key={`row-seat-wrapper-${seat.row + 1}`}
                    row={rowItems}
                    rowNumber={seat.row + 1}
                    selectedPassenger={selectedPassenger}
                    selectSeat={this.selectSeat}
                    exitRow={exitRow}
                  />
                );
              }
            } else {
              currentRow = seat.row;
              let rowItemsForRendering = Object.assign([], rowItems);
              rowItems = [ seat ];
              return (
                <RowSeatContainer
                  key={`row-seat-wrapper-${currentRow}`}
                  row={rowItemsForRendering}
                  rowNumber={currentRow}
                  selectedPassenger={selectedPassenger}
                  selectSeat={this.selectSeat}
                  exitRow={exitRow}
                />
              );
            }
          })}
        </div>
      );
    }

    return null;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeatSelection);



// WEBPACK FOOTER //
// ./src/containers/seats/common/seatSelection/SeatSelection.js